/**
 * @generated SignedSource<<78a18f38ffa59b824fb6dec8b6d4caf4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpsertUserSurveyMutationPayload",
    "kind": "LinkedField",
    "name": "upsertUserSurvey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ConversionFormContextProviderUpsertUserSurveyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ConversionFormContextProviderUpsertUserSurveyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "24981ee4e5c4949313ca183b1778317f",
    "id": null,
    "metadata": {},
    "name": "ConversionFormContextProviderUpsertUserSurveyMutation",
    "operationKind": "mutation",
    "text": "mutation ConversionFormContextProviderUpsertUserSurveyMutation(\n  $input: UpsertUserSurveyMutationInput!\n) {\n  upsertUserSurvey(input: $input) {\n    email\n  }\n}\n"
  }
};
})();

node.hash = "bf37520004254332ba10630dcaf9d6d9";

module.exports = node;
